// ======================================================================
// File Name       : CourseHistorySearchResult
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form, Table } from 'react-bootstrap';
import ReduxFormPaging from '../../../components/ReduxFormPaging';
import { HYPHEN } from '../../../constants';
import { END_CONDITION_TYPE_FOR_COURSE } from '../../../constants/CourseConstants';
import * as Path from '../../../constants/PathConstants';
import CustomLink from '../../button/CustomLink';
import * as ICON from '../../../constants/IconConstants';

class CourseHistorySearchResult extends React.Component {
  render() {
    const {
      courseHistoryList,
      handleSortState,
      recordNum,
      getStartEndData,
      startPosition,
      courseHistoryStatus,
      dataSort,
      goToDetail,
      handleMouseEnter,
      handleMouseLeave,
    } = this.props;
    const thead = [
      { title: 'コース名', sortBy: 1 },
      { title: 'コンテンツ総数', sortBy: null , width: '10%'},
      { title: 'ユーザー数', sortBy: null , width: '10%'},
      { title: 'コース完了ユーザー数', sortBy: null , width: '10%'},
      { title: '操作', sortBy: null, width: 130 },
    ];
    // table data
    let historyTableData = null;
    if (courseHistoryList) {
      historyTableData = courseHistoryList.map((historyData, index) => {
        const itemCount = courseHistoryStatus[historyData.courseSecernId] &&
          courseHistoryStatus[historyData.courseSecernId].itemCount ?
          courseHistoryStatus[historyData.courseSecernId].itemCount : 0;
        const attendingUserCount = courseHistoryStatus[historyData.courseSecernId] &&
          courseHistoryStatus[historyData.courseSecernId].attendingUserCount ?
          courseHistoryStatus[historyData.courseSecernId].attendingUserCount : 0;
        const endConditionAchievementUserCount = courseHistoryStatus[historyData.courseSecernId] &&
          courseHistoryStatus[historyData.courseSecernId].endConditionAchievementUserCount ?
          courseHistoryStatus[historyData.courseSecernId].endConditionAchievementUserCount : 0;
        // #7436 START
        const isNotSetEndConditionTypeForCourse = historyData.endConditionTypeForCourse === END_CONDITION_TYPE_FOR_COURSE.NONE;
        // #7436 END
        const link = Path.USER_HISTORY_COURSE_DETAIL.replace(':id', historyData.courseSecernId);
        return (
          <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
            <td>{historyData.courseName}</td>
            <td className="text-right" >{itemCount}</td>
            <td className="text-right" >{attendingUserCount}</td>
            {/* #7436 START */}
            <td className="text-right" >{isNotSetEndConditionTypeForCourse ? HYPHEN : endConditionAchievementUserCount}</td>
            {/* #7436 END */}
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail"
                to={link}
                text="詳細を見る"
              />
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover className="margin-top-10">
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="courseStatusSortType"
              handleSortState={handleSortState}
             />
          </thead>
          <tbody>
            {historyTableData}
          </tbody>
        </Table>
        <Form className='form-horizontal'>
          <Form.Group>
            <Col sm={12} className="text-center">
              <ReduxFormPaging
                type="paging"
                name="startPosition"
                recordNum={recordNum}
                getStartEndData={getStartEndData}
              />
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}
export default CourseHistorySearchResult;
